/**
 * Converts a number into a currency-formatted string: $#.##
 * @param num the number to convert into a currency-formatted string
 * @returns currency-formatted string
 */

export default class Formatter {
	/** @deprecated. Use formatCurrency instead. */
	static currencyFormat(num: number): string {
		return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
	}

	static formatCurrency(
		num: number,
		currency: string = 'CAD',
		minimumFractionDigits: number = 2
	): string {
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: currency.toUpperCase(),
			minimumFractionDigits,
			currencyDisplay: 'narrowSymbol', // Displays the currency symbol without the currency name. CA$100 -> $100.
		})
		return formatter.format(num)
	}

	// Useful for formatting phone numbers when given in full.
	static phoneNumber(phoneNumber: string): string {
		let cleaned = phoneNumber.replace(/\D/g, '')

		if (cleaned.length === 11 && cleaned.startsWith('1')) {
			cleaned = cleaned.substring(1)
		}

		if (cleaned.length !== 10) {
			return 'Invalid phone number'
		}

		const areaCode = cleaned.substring(0, 3)
		const middlePart = cleaned.substring(3, 6)
		const lastPart = cleaned.substring(6)

		return `(${areaCode})-${middlePart}-${lastPart}`
	}

	// Useful for formatting phone numbers when not given in full.
	static formatPhoneNumber(phoneNumber: string): string {
		const numbers = phoneNumber.replace(/\D/g, '').split('')
		const char = { 0: '(', 3: ')-', 6: '-' }
		return numbers.map((n, i) => (char[i] || '') + n).join('')
	}

	static encodedEmail(email: string): string {
		return (
			'relay+' + email.toLowerCase().replace(/@/g, '%') + '%' + global.org + '@nextgenkitchens.com'
		)
	}

	static decodedEmail(relayEmail: string): string {
		if (relayEmail.startsWith('relay+')) {
			// Extract between 'relay+' and second '%'
			const regex = /relay\+([^%]+%[^%]+)%/
			const match = relayEmail.match(regex)

			if (match && match[1]) {
				return match[1].replace('%', '@')
			} else {
				return relayEmail
			}
		} else {
			return relayEmail
		}
	}

	// Remove all non-numeric characters and format in groups of 4
	static formatGiftCardCode(code: string): string {
		// Remove non-hex characters and spaces, if any.
		const sanitizedCode = code.replace(/[^a-fA-F0-9]/g, '')
		// Format the code by adding a space every 4 characters
		return sanitizedCode.replace(/(.{4})(?=.)/g, '$1 ')
	}
}
